<template>
  <el-input
    type="textarea"
    autosize
    v-model="mValue"
    :placeholder="placeholder"
    @keyup.native="nextFocus($event, BlocksIndex)"
  ></el-input>
</template>

<script>
import NextFoucsMixin from "@/components/mixin/NextFoucsMixin";

export default {
  name: "BaseTextBlock",
  props: {
    value: String,
    BlocksIndex: Number,
    placeholder: String,
  },
  mixins: [NextFoucsMixin],
  data() {
    return {
      mValue: this.value,
    };
  },
  watch: {
    mValue: {
      handler(val) {
        //本地值改变传给父组件
        this.$emit("input", val);

        let blockInfo = {
          index: this.BlocksIndex,
          text: val,
        };
        this.$store.commit("mutationUpdateInputBlockText", blockInfo);
      },
    },
    value(val) {
      this.mValue = val;
    },
  },
  methods: {},
  computed: {
    currentPageBlocks() {
      return this.$store.state.currentPageBlocks;
    },
  },
};
</script>
